/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_sidebar_user_fallback = /** @type {(inputs: {}) => string} */ () => {
	return `Usuario`
};

const en_sidebar_user_fallback = /** @type {(inputs: {}) => string} */ () => {
	return `User`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const sidebar_user_fallback = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sidebar_user_fallback(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sidebar_user_fallback", locale)
	if (locale === "es") return es_sidebar_user_fallback(inputs)
	return en_sidebar_user_fallback(inputs)
};
export { sidebar_user_fallback as "sidebar.user_fallback" }